import React from 'react';
import { ConfigProvider } from 'antd';
import { IntlProvider } from 'react-intl';
import { useSelector } from 'react-redux';
import { ThemeProvider } from 'styled-components';
import themes from '@iso/config/theme/theme.config';
import AppLocale from '@iso/config/translation';

export default function AppProvider({ children }) {
  const { locale } = useSelector(state => state.LanguageSwitcher.language);
  const { themeName } = useSelector(state => state.ThemeSwitcher.changeThemes);
  const currentAppLocale = AppLocale[locale];
  return (
    <ConfigProvider
      locale={currentAppLocale.antd}
      /* Todo popup do antd (dropdown, menu de "3 pontinhos", select, calendário,
         popover) renderiza no BODY — assim nunca fica recortado pelo bloco nem
         atrás da janela/modal; a camada vem do z-index global (2750). */
      getPopupContainer={(triggerNode) => {
        const doc = triggerNode && triggerNode.ownerDocument;
        return (doc && doc.body) || document.body;
      }}
    >
      <IntlProvider
        locale={currentAppLocale.locale}
        messages={currentAppLocale.messages}
      >
        <ThemeProvider theme={themes[themeName]}>{children}</ThemeProvider>
      </IntlProvider>
    </ConfigProvider>
  );
}
